import { render, staticRenderFns } from "./website-digital.vue?vue&type=template&id=07d6c1cc&scoped=true"
import script from "./website-digital.vue?vue&type=script&lang=js"
export * from "./website-digital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d6c1cc",
  null
  
)

export default component.exports